import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {
  1: { // Exercise num
    unit: 'Unit 12',
    id: 'WB4-V2-U12-P83-E1',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page83/E1/Key/answerKey.png',
    inputSize: 139,
    textAlign: 'center',
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page83/E1/1.jpg' /> </div>
          <div style=" position: absolute; top: 337px; left: 595px; "><input id='0' /></div>
          <div style=" position: absolute; top: 514px; left: 595px; "><input id='1' /></div>
        </div>
        `,
        answer: [
          "cube",
          "pine",
        ],
      },
    ],
  },
  2: { // Exercise num
    unit: 'Unit 12',
    id: 'WB4-V2-U12-P83-E2',
    audio: 'img/FriendsPlus/Page83/Audio/audio-e2-p83.mp3',
    video: '',
    component: T6,
    checkUppercase: true,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page83/E2/Key/answerKey.png',
    inputSize: 105,
    titleQuestion: [{ num: '2', title: 'Listen and write. Then listen again and repeat. <headphone name="25" src="img/FriendsPlus/Page83/Audio/tieude-e2-p83.mp3"></headphone>', color: "#5B5A5D" }],
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page83/E2/1.jpg' /> </div>
          <div style=" position: absolute; top: 119px; left: 31px; "><input id='0' /></div>
          <div style=" position: absolute; top: 167px; left: 30px; "><input id='1' /></div>
          <div style=" position: absolute; top: 225px; left: 192px; "><input id='2' /></div>
          <div style=" position: absolute; top: 225px; left: 464px; "><input id='3' /></div>
          <div style=" position: absolute; top: 379px; left: 192px; "><input id='4' /></div>
          <div style=" position: absolute; top: 379px; left: 413px; "><input id='5' /></div>

        </div>
        `,
        answer: [
          "Cub",
          "Cube",
          "pin",
          "pine",
          "cap",
          "cape",
        ],
      },
    ],
  },




}
export default json;